import { RECEIVE_AUTOCOMPLETE_PRODUCTS, REQUEST_AUTOCOMPLETE_PRODUCTS, SEARCH_TOGGLE } from './types';

export function toggleSearch(value) {
  return {
    type: SEARCH_TOGGLE,
    value
  };
}

export function requestAutoCompleteProducts() {
  return {
    type: REQUEST_AUTOCOMPLETE_PRODUCTS
  };
}

export function receiveAutoCompleteProducts(response) {
  return {
    type: RECEIVE_AUTOCOMPLETE_PRODUCTS,
    response
  };
}
